// extracted by mini-css-extract-plugin
module.exports = {"modalBody":"IndexPage_modalBody__j750c","styledSelect":"IndexPage_styledSelect__1D4Ad"};